import { AURR_STATE_STORAGE_KEY } from '../constants';

export const getAuthState = () => {
  const cachedStateJSON = localStorage.getItem(AURR_STATE_STORAGE_KEY);
  return cachedStateJSON ? JSON.parse(cachedStateJSON) : null;
};
